export enum SegmentBenefitNameEnum {}

export enum SegmentBenefitTitlePage {
  '/company/benefits/' = 'Listagem Beneficios'
}

export enum SegmentBenefitEventName {
  'page_benefits' = 'People - Benefits Module - Page view',
  'page_view_benefits' = 'People: Benefits Module - Page View Page',
  'card_food_benefits' = 'People: Benefits Module - Card Food',
  'card_basic_basket_benefits' = 'People: Benefits Module - Card Basic Basket',
  'add_benefit_button' = 'People: Benefits Module - Add Benefit Button',
  'modal_new_befits_view' = 'People: Benefits Module - Page View Modal New Benefits',
  'modal_new_benefits_cancel' = 'People: Benefits Module Modal - Cancel Button',
  'modal_new_benefits_add' = 'People: Benefits Module Modal - Add Button',
  'setup_food_cancel' = 'People: Benefits Module Setup Page - Cancel Button',
  'setup_food_add' = 'People: Benefits Module Setup Page - Add Button',
  'registered_add_button_food_benefit' = 'People: Registered Benefits Page - Button Benefits',
  'registered_edit_button_benefit' = 'People: Registered Benefits Page - Button Edit',
  'registered_delete_button_food_benefit' = 'People: Registered Benefits Page - Button Delete',
  'setup_cesta_basica_cancel' = 'People: Benefits Setup Page - Cancel Button',
  'setup_cesta_basica_add' = 'People: Benefits Setup Page - Add Button',
  'modal_new_rules_view' = 'People Settings - Eligibility page - View Modal New Rules',
  'modal_new_rules_add' = 'People Settings - Eligibility page - View Modal Progress Button',
  'modal_new_rules_cancel' = 'People Settings - Eligibility page - View Modal Cancel Button',
  'modal_delete_rule' = 'People Settings - Eligibility page - Modal Delete Rule',
  'button_delete_rule' = 'People Settings - Eligibility page - Delete Rule',
  'create_first_rule_button' = 'People Settings - Eligibility page - Create Rule Button',
  'eligibility_page_view' = 'People Settings - Eligibility Page View',
  'eligibility_page_number_of_rules' = 'People Settings - Amount Of Rules Of Elegibility',
  'modal_rule_conflict' = 'People Settings - Eligibility page - Setup Page Modal Rule Conflict',
  'button_save_new_eligibity' = 'People Settings - Eligibility page - Setup Page Save Button',
  'create_more_rules_button' = 'People Settings - Eligibility page - Create Rule',
  'modal_details_rules_view' = 'People Settings - Eligibility page - View Modal Detail Rules',
  'modal_details_rules_close_button' = 'People Settings - Eligibility page - View Modal Detail Rules Close Button',
  'create_template_link' = 'People: Benefits Setup Page - Create subscription template',
  'create_benefit_transport_monitoring' = 'People: Benefits Setup Page - Scripter type',
  'cancel_button_create_benefit_transport' = 'People: Benefits Setup Page - Cancel Button',
  'save_button_create_benefit_transport' = 'People: Registered Benefits Page - Button Save',
  'card_transport_click' = 'People: Benefits Module - Card Transport',
  'add_button_tranport' = 'People: Benefits Module - Add button',
  'delete_button_benefit_transport' = 'People: Benefits Module - Delete button',
  'edit_button_benefit_transport' = 'People: Benefits Module - Edit button',
  'add_button_modal_transport' = 'People: Benefits Module Modal - Add button',
}

export enum SegmentBenefitPageView {}
